import React from 'react';
import StatisticsPage from '../components/supplierStats/StatisticsPage';
export default function SupplierStatsSuppliers() {
  return <StatisticsPage kind="suppliers" />;
}
